// @ts-nocheck
// Page: consent-reprocessing  (contract reprocessing / re-signing flow)
//
// Ported from the inline <script> in
//   Enrollment_modules/consent-reprocessing/form.module/module.html (lines 111–1815).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. No inline event handlers in markup — no bind() section needed.
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl() (10 URLs).
//   3. localStorage -> storage.rawGet/rawSet/rawRemove.
//   4. @ts-nocheck for bare-minimum migration; proper typing is a follow-up.
// NOTE: AdobeSign (api.na3.adobesign.com, secure.na3.echosign.com),
//   api.nautilussolar.com, api.hubapi.com, js.stripe.com kept literal.

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

export function init(_root: HTMLElement, _config: unknown): void {
__ea_trace("modules/consent/consent-reprocessing.ts","init",[_root,_config],["_root","_config"]);
  /* -------------- stripe js --------------- */
  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 120s timer and the interval-leak are gone
  // by construction. A deferred audit will split this into read vs mutation
  // withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBar(message = "We are saving your payment information") {
__ea_trace("modules/consent/consent-reprocessing.ts","openProgressBar",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBar() {
__ea_trace("modules/consent/consent-reprocessing.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  var _successMessage = ""
  var _paymentServiceProvider = ""
  var _responseFromAPI = ""

  /* loader function */
  function _paymentRequiredOpenLoader() {
__ea_trace("modules/consent/consent-reprocessing.ts","_paymentRequiredOpenLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function _paymentRequiredCloseLoader() {
__ea_trace("modules/consent/consent-reprocessing.ts","_paymentRequiredCloseLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  /* loader function */

  // If user is not logedIn then redirected them to login page -------------------------------------------------
  //     function getEmail() {
  //         var storedEmail = storage.rawGet("userEmail");
  //         if (!storedEmail) {
  //             window.location.href =
  //                 "https://enrollment.nautilussolar.com/";
  //             return false;
  //         }
  //     }
  //     getEmail();
  // If user is not logedIn then redirected them to login page -------------------------------------------------
  var utilityId = ""
  async function _delay(ms) {
__ea_trace("modules/consent/consent-reprocessing.ts","_delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  /* -------------------------------------------------------- CO Re-process -------------------------------------------- */
  var customerPath = ""
  var customerEmail = ""
  var contractId = ""
  var dealrecordId = ""
  var pageView = ""
  var selfServeUrl = ""

  async function decrypteEmail(_value) {
__ea_trace("modules/consent/consent-reprocessing.ts","decrypteEmail",[_value],["_value"]);
    selfServeUrl = storage.rawGet("selfServeUrl")
    localStorage.clear()
    storage.rawSet("selfServeUrl", selfServeUrl)
    openProgressBar("Fetching Adobe agreement URL...")

    const urlParams = new URLSearchParams(window.location.search)
    const hasAuth = urlParams.has("auth") //
    if (hasAuth) {
    } else {
      alert("Found issue in Url")
      return
    }
    const authValue = urlParams.get("auth")

    fetch(apiUrl("dcrypt-the-email"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ encryptedEmail: authValue }),
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[data],["data"]);
        customerPath = data.email
        const parts = customerPath.split("|")
        // parts[0] will be the email
        customerEmail = parts[0]
        // parts[1] will be the number
        contactId = parts[1]
        contractId = parts[2]
        dealrecordId = parts[3]
        storage.rawSet("customerEmail", customerEmail)
        storage.rawSet("contactId", contactId)
        storage.rawSet("contractId", contractId)
        storage.rawSet("dealrecordId", dealrecordId)
        GetDataFromDealRecord(customerEmail, contractId, dealrecordId)
      })
      .catch((error) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[error],["error"]);
        closeProgressBar()
        console.error("Error:", error)
      })
  }
  // ------------- Get saved data -------------------------------
  var limitt = 1000
  var offsett = 0
  var allFarmRowss = []
  function checkUtilityIdInFarmTable(U_Id) {
__ea_trace("modules/consent/consent-reprocessing.ts","checkUtilityIdInFarmTable",[U_Id],["U_Id"]);
    //live farm table id 15223639
    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityFarm}/rows?portalId=${window.__ENV__.dataPortalId}&limit=${limitt}&offset=${offsett}`
    fetch(hubDBEndpoint, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[data],["data"]);
        const matchingRowss = data.objects.filter((row) => row.values[10] === U_Id)
        const rowss = data.objects
        allFarmRowss = allFarmRowss.concat(matchingRowss)
        if (rowss.length === limitt) {
          // There might be more rows, fetch the next page
          offsett += limitt
          return checkUtilityIdInFarmTable(U_Id)
        }
        const priorityArray = []
        var _inc = 0
        for (var i = 0; i <= allFarmRowss.length; i++) {
          const currentobj = allFarmRowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          if (
            FarmStateAbbreviation === "ME" ||
            FarmStateAbbreviation === "CO" ||
            FarmStateAbbreviation === "DE" ||
            FarmStateAbbreviation === "NY" ||
            FarmStateAbbreviation === "MD" ||
            FarmStateAbbreviation === "MN" ||
            FarmStateAbbreviation === "IL"
          ) {
            ++_inc
            const FarmZip = currentobj.values[6]
            const FarmName = currentobj.values[7]
            const FarmID = currentobj.values[1]
            const priority = currentobj.values[12]
            const FarmDisplayName = currentobj.values[2]
            const FarmStreetAddress1 = currentobj.values[3]
            const FarmStreetAddress2 = currentobj.values[13]
            const FarmCity = currentobj.values[4]
            const FarmEmail = currentobj.values[28]
            const FarmPhoneNumber = currentobj.values[23]
            const FarmProjectDescription = currentobj.values[22]
            const FarmLlc = currentobj.values[21]
            const FarmLMIDiscount = currentobj.values[19]
            const FarmOpenDiscount = currentobj.values[20]
            const FarmCounty = currentobj.values[35]
            const myObject = {
              FarmZip: FarmZip,
              FarmName: FarmName,
              FarmID: FarmID,
              priority: priority,
              FarmDisplayName: FarmDisplayName,
              FarmStreetAddress1: FarmStreetAddress1,
              FarmStreetAddress2: FarmStreetAddress2,
              FarmCity: FarmCity,
              FarmEmail: FarmEmail,
              FarmStateAbbreviation: FarmStateAbbreviation,
              FarmPhoneNumber: FarmPhoneNumber,
              FarmProjectDescription: FarmProjectDescription,
              FarmLlc: FarmLlc,
              FarmLMIDiscount: FarmLMIDiscount,
              FarmOpenDiscount: FarmOpenDiscount,
              FarmCounty: FarmCounty,
            }
            if (currentobj.values[9] === 1) {
              priorityArray.push(myObject)
            }
          }
          if (i === allFarmRowss.length - 1) {
            if (priorityArray.length > 0) {
              // Now correspondingObject contains the object with the lowest priority
              const minPriorityObject = priorityArray.reduce(
                (min, obj) => (obj.priority < min.priority ? obj : min),
                priorityArray[0],
              )
              storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
              storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
              storage.rawSet("FarmCity", minPriorityObject.FarmCity)
              storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
              storage.rawSet("FarmName", minPriorityObject.FarmName)
              storage.rawSet("FarmID", minPriorityObject.FarmID)
              storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
              storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
              storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
              storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
              storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
              storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
              storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
              storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)
              break
            } else {
              break
            }
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }
  async function addPageViewCountToContactRecord(viewCount) {
__ea_trace("modules/consent/consent-reprocessing.ts","addPageViewCountToContactRecord",[viewCount],["viewCount"]);
    var email = storage.rawGet("customerEmail")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          re_sign_doc_view: viewCount,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data

      const result = await response.json()
      _responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function addPageViewCountToContracts(value) {
__ea_trace("modules/consent/consent-reprocessing.ts","addPageViewCountToContracts",[value],["value"]);
    var contractId = storage.rawGet("contractId")
    try {
      const prop = {
        properties: {
          re_sign_doc_view: value,
        },
      }
      const response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })

      const _result = await response.json()
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function getContactRecord(email) {
__ea_trace("modules/consent/consent-reprocessing.ts","getContactRecord",[email],["email"]);
    var _catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      _responseFromAPI = JSON.stringify(dataa)
      var firstName = dataa.userValue.properties.firstname
      var lastName = dataa.userValue.properties.lastname
      var _birthdateInput = dataa.userValue.properties.date_of_birth
      var homeNumber = dataa.userValue.properties.phone
      var cellNumber = dataa.userValue.properties.mobilephone
      var recordId = dataa.userValue.properties.hs_object_id
      pageView = dataa.userValue.properties.re_sign_doc_view
      storage.rawSet("RecordId", recordId)
      storage.rawSet("LoggedName", `${firstName} ${lastName}`)
      storage.rawSet("CompanyName", `${firstName}&${lastName}`)
      storage.rawSet("FirstName", firstName)
      storage.rawSet("LastName", lastName)
      storage.rawSet("LastName", lastName)

      if (homeNumber != null && homeNumber !== undefined) {
        storage.rawSet("HomePhone", homeNumber)
      }
      if (cellNumber != null && cellNumber !== undefined) {
        storage.rawSet("CellPhone", cellNumber)
      }
      if (
        pageView == null ||
        pageView === undefined ||
        pageView === "" ||
        pageView === "null" ||
        pageView === "undefined" ||
        pageView === "0" ||
        pageView === 0
      ) {
        await addPageViewCountToContactRecord(1)
        await addPageViewCountToContracts(1)
      } else {
        pageView = parseInt(pageView, 10) + 1
        await addPageViewCountToContactRecord(pageView)
        await addPageViewCountToContracts(pageView)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function getContractRecord(state, utilityId) {
__ea_trace("modules/consent/consent-reprocessing.ts","getContractRecord",[state,utilityId],["state","utilityId"]);
    var contractId = storage.rawGet("contractId")
    var _catchdata = ""
    try {
      const data = {
        id: contractId,
      }
      const response = await fetch(apiUrl("get-contracts-reprocess"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      _responseFromAPI = JSON.stringify(dataa)
      var ssk = dataa.properties.subscription_size_kwac
      storage.rawSet("subscription_size_kWAC", ssk)
      var srId = dataa.properties.subscription_record_id
      storage.rawSet("subscription_record_id", srId)

      if (state !== "IL") {
        if (utilityId === "XCEL-CO-SF") {
          document.querySelector(".disclosureAgreement-Wrapper").style.display = "none"
          document.querySelector(".dataConsentAgreement-wrapper").style.display = "block"
          var dataConsent_adobe_agreement_id = dataa.properties.dataconsent_adobe_agreement_id
          var dcDocStatusOnLoad = dataa.properties.data_consent_document_status
          var er_number = dataa.properties.er_number
          storage.rawSet("ErNumber", er_number)

          if (dcDocStatusOnLoad !== "SIGNED") {
            if (
              dataConsent_adobe_agreement_id == null ||
              dataConsent_adobe_agreement_id === "null" ||
              dataConsent_adobe_agreement_id === ""
            ) {
              await createDataConsentAdobeAgreement()
            } else {
              storage.rawSet("DataConsentagreementId", dataConsent_adobe_agreement_id)
              await sendDataConsentAgreementIdToGetStatus(dataConsent_adobe_agreement_id)
            }
          } else {
            alert("document is already signed")
            document.querySelector(".dc-thankyou p a").href = selfServeUrl
            document.querySelector(".dc-thankyou").style.display = "block"
            document.querySelector("#firstStepButton").style.display = "none"
            document.querySelector(".dataConsentAgreement").style.display = "none"
            closeProgressBar()
            setTimeout(() => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
              if (selfServeUrl == null || selfServeUrl === "null") {
                window.location.href = "/"
              } else {
                window.location.href = selfServeUrl
              }
            }, 3000)
          }
        } else {
          console.error("Utility id is not XCEL-CO-SF")
        }
      } else {
        document.querySelector(".disclosureAgreement-Wrapper").style.display = "block"
        document.querySelector(".dataConsentAgreement-wrapper").style.display = "none"
        var dis_adobe_agreement_id = dataa.properties.adobe_agreement_id
        var dis_il_formid = dataa.properties.il_formid
        var er_number = dataa.properties.er_number
        storage.rawSet("ErNumber", er_number)

        if (dis_adobe_agreement_id == null || dis_adobe_agreement_id === "null" || dis_adobe_agreement_id === "") {
          await sendDatatoCreateDisclouser()
        } else {
          storage.rawSet("DisagreementId", dis_adobe_agreement_id)
          storage.rawSet("formId", dis_il_formid)
          await getAgreementUrl(dis_adobe_agreement_id)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function GetDataFromDealRecord(customerEmail, _contractId, dealrecordId) {
__ea_trace("modules/consent/consent-reprocessing.ts","GetDataFromDealRecord",[customerEmail,_contractId,dealrecordId],["customerEmail","_contractId","dealrecordId"]);
    var _catchdata = ""
    try {
      const data = {
        deal_id: dealrecordId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      _responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        utilityId = dataa.userValue.properties.utility_id
        var lmiOption = dataa.userValue.properties.lmi_option
        var uan_1_value = dataa.userValue.properties.uan_1_value
        if (uan_1_value == null || uan_1_value === undefined || uan_1_value === "null" || uan_1_value === "undefined") {
          uan_1_value = ""
        }
        var uan_2_value = dataa.userValue.properties.uan_2_value
        if (uan_2_value == null || uan_2_value === undefined || uan_2_value === "null" || uan_2_value === "undefined") {
          uan_2_value = ""
        }
        var additionalAttribute = dataa.userValue.properties.uan_2_internal_value
        var utilityAccountNumber = dataa.userValue.properties.combined_utility_account_number
        if (
          utilityAccountNumber == null ||
          utilityAccountNumber === undefined ||
          utilityAccountNumber === "null" ||
          utilityAccountNumber === "undefined"
        ) {
          utilityAccountNumber = ""
        }
        var address1 = dataa.userValue.properties.street_address
        var address2 = dataa.userValue.properties.street_address_2
        if (address1 == null || address1 === undefined || address1 === "null" || address1 === "undefined") {
          address1 = ""
        }
        if (address2 == null || address2 === undefined || address2 === "null" || address2 === "undefined") {
          address2 = ""
        }
        var city = dataa.userValue.properties.city
        if (city == null || city === undefined || city === "null" || city === "undefined") {
          city = ""
        }
        var state = dataa.userValue.properties.service_state_abbreviation
        if (state == null || state === undefined || state === "null" || state === "undefined") {
          state = ""
        }
        var postal = dataa.userValue.properties.postal_code
        if (postal == null || postal === undefined || postal === "null" || postal === "undefined") {
          postal = ""
        }
        var bayousId = dataa.userValue.properties.bayous_id
        var meterId = dataa.userValue.properties.meter_id
        var papk = dataa.userValue.properties.payment_amount_per_kwh
        var gep = dataa.userValue.properties.gross_electricity_production
        if (papk == null || papk === undefined || papk === "null" || papk === "undefined") {
          papk = ""
        }
        if (gep == null || gep === undefined || gep === "null" || gep === "undefined") {
          gep = ""
        }
        storage.rawSet("lmi_option", lmiOption)
        storage.rawSet("uan1Value", uan_1_value)
        storage.rawSet("uan2Value", uan_2_value)
        storage.rawSet("additionalAttribute", additionalAttribute)
        storage.rawSet("utilityAccountNumber", utilityAccountNumber)
        storage.rawSet("Street Address", `${address1} ${address2}`)
        storage.rawSet("street_address", address1)
        storage.rawSet("street_address_2", address2)
        storage.rawSet("city", city)
        storage.rawSet("StateAbbreviation", state)
        storage.rawSet("ZipCode", postal)
        storage.rawSet("utility_id", utilityId)
        storage.rawSet("bayousId", bayousId)
        storage.rawSet("meterId", meterId)
        storage.rawSet("gross_electricity_production", gep)
        storage.rawSet("payment_amount_per_kwh", papk)
        checkUtilityIdInFarmTable(utilityId)
        await GetSubscriptionAndDisclosureFromSessionConfigTable()
        await getContactRecord(customerEmail)
        await getContractRecord(state, utilityId)
        var _utilityDetails = storage.rawGet("UtilitySessionDetails")
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  // ------------- Get saved data -------------------------------

  // get Subscription and Disclosure from session config table ----------------------------------------------------
  async function GetSubscriptionAndDisclosureFromSessionConfigTable() {
__ea_trace("modules/consent/consent-reprocessing.ts","GetSubscriptionAndDisclosureFromSessionConfigTable",[],[]);
    var u_id = storage.rawGet("utility_id")
    try {
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id=${u_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        storage.rawSet("UtilitySessionDetails", JSON.stringify(rows[0].values))
        storage.rawSet("stateForLMIConfig", rows[0].values["13"].name)
        storage.rawSet("UtilityRate", rows[0].values["78"])
        storage.rawSet("SubSizingFactor", rows[0].values["79"])
        storage.rawSet("standardRate", rows[0].values["80"])
        storage.rawSet("lmiNseRate", rows[0].values["81"])
        storage.rawSet("standardRate", rows[0].values["80"])
        storage.rawSet("lmiNseRate", rows[0].values["81"])
        storage.rawSet("acSystemSize", rows[0].values["82"])
        storage.rawSet("acKwh", rows[0].values["84"])
        storage.rawSet("DisclosureSubType", rows[0].values["76"][0].label)
        storage.rawSet("DataContentSubType", rows[0].values["86"][0].label)

        var _disclosure = rows[0].values[65]
        var _subscriptionAgreement = rows[0].values[66]
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  // get Subscription and Disclosure from session config table ----------------------------------------------------

  async function updateDataConsentAgreementId(value, value1) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateDataConsentAgreementId",[value,value1],["value","value1"]);
    var contractId = storage.rawGet("contractId")
    try {
      var prop = {
        properties: {
          dataconsent_adobe_agreement_id: value,
          create_data_consent_response: value1,
        },
      }

      const response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })

      if (response.ok) {
        await getDataConsentAgreementUrl(value)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function getDataConsentAgreementUrl(adobe_agreement_id) {
__ea_trace("modules/consent/consent-reprocessing.ts","getDataConsentAgreementUrl",[adobe_agreement_id],["adobe_agreement_id"]);
    try {
      openProgressBar("Fetching Adobe agreement URL...")
      const endpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`
      const response = await fetch(endpoint, {
        method: "GET",
      })
      if (!response.ok) {
        throw new Error(`Adobe API returned status ${response.status}`)
      }
      const result = await response.json()
      const signingUrl = result.data.signingUrlSetInfos?.[0]?.signingUrls?.[0]?.esignUrl

      const iframe = document.createElement("iframe")
      iframe.src = signingUrl
      iframe.width = "750"
      iframe.height = "500"
      iframe.style.border = "none"
      const container = document.querySelector(".dataConsentAgreement")
      container.innerHTML = ""
      container.appendChild(iframe)
      closeProgressBar()
    } catch (error) {
      closeProgressBar()
      console.error("Error in getDataConsentAgreementUrl:", error)
    }
  }
  async function createDataConsentAdobeAgreement() {
__ea_trace("modules/consent/consent-reprocessing.ts","createDataConsentAdobeAgreement",[],[]);
    const url = "https://api.na3.adobesign.com/api/rest/v6/agreements"
    const body = {
      name: `${`${storage.rawGet("LoggedName")} ${storage.rawGet("contractId")}`}`, // Change dynamically
      fileInfos: [
        {
          libraryDocumentId: "CBJCHBCAABAA8TGpNz0J5vOLybOw-urSDENkBTM9N5DN",
        },
      ],
      participantSetsInfo: [
        {
          memberInfos: [
            {
              email: `${storage.rawGet("customerEmail")}`, // Change dynamically
            },
          ],
          order: 1,
          role: "SIGNER",
        },
      ],
      mergeFieldInfo: [
        {
          fieldName: "Customer Account Number",
          defaultValue: `${storage.rawGet("uan1Value") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "UAN 2",
          defaultValue: `Prem #: ${storage.rawGet("uan2Value") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Service Address",
          defaultValue: `${storage.rawGet("Street Address") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "City",
          defaultValue: `${storage.rawGet("city") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "State",
          defaultValue: `${storage.rawGet("StateAbbreviation") ?? ""}`,
        },
        {
          fieldName: "Zip",
          defaultValue: `${storage.rawGet("ZipCode") ?? ""}`, // Change dynamically
        },
        {
          fieldName: "Name",
          defaultValue: `${storage.rawGet("LoggedName") ?? ""}`, // Change dynamically
        },
      ],
      signatureType: "ESIGN",
      state: "IN_PROCESS",
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 3AAABLblqZhC1dTtXjAGGLK1S-DirIkemdHclBxXjGIGEuShgkiyadXjkcdGXsry5NWv8b2MK5ETTbLanqoFu8pGo0yZFqfRI",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      storage.rawSet("DataConsentagreementId", data.id)
      await updateDataConsentAgreementId(data.id, JSON.stringify(data))
    } catch (error) {
      console.error("Error creating Adobe agreement:", error)
    }
  }
  async function sendDataConsentAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-reprocessing.ts","sendDataConsentAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealId")
    var dataConsentId = storage.rawGet("DataConsentagreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${dataConsentId}`
      const response = await fetch(hubDBEndpoint, {
        method: "GET",
      })
      const res = await response.json()
      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        await getDataConsentAgreementUrl(dataConsentId)
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        openProgressBar("We are loading your payment options")
        storage.rawSet("dataConsentSignatureStatus", "SIGNED")
        await updateDataConsentAdobeUrl(res.url, res.hubspot.url, res.hubspot.id, "SIGNED")
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function updateDataConsentAdobeUrl(value, value1, value2, value3) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateDataConsentAdobeUrl",[value,value1,value2,value3],["value","value1","value2","value3"]);
    var DataContentSubType = storage.rawGet("DataContentSubType")
    var dealId = storage.rawGet("dealrecordId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          saa_document_sub_type_3: DataContentSubType,
          lmi_saa_doc_file_3: value1,
          saa_doc_file_3_id: value2,
          data_consent_document_status: value3,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await updateDataConsentAdobeUrlInContracts(value, value1, value2, value3)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function createNseServiceForDataConsent(_value, value1, value2, value3) {
__ea_trace("modules/consent/consent-reprocessing.ts","createNseServiceForDataConsent",[_value,value1,value2,value3],["_value","value1","value2","value3"]);
    var _utilityDetails = storage.rawGet("UtilitySessionDetails")
    var _dealId = storage.rawGet("dealrecordId")
    var contactId = storage.rawGet("contactId")
    var nseContractId = storage.rawGet("contractId")
    var ErNumber = storage.rawGet("ErNumber")
    var DataContentSubType = storage.rawGet("DataContentSubType")
    var nseSubId = storage.rawGet("subscription_record_id")

    try {
      var serviceActionResponse = await fetch(apiUrl("create-nse-service-action-for-re-process"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          er_number: ErNumber,
          lmi_saa_doc_file_3: value1,
          saa_doc_file_3_id: value2,
          data_consent_document_status: value3,
          saa_document_sub_type_3: DataContentSubType,
        }),
      })
      const serviceActionData = await serviceActionResponse.json()
      _responseFromAPI = JSON.stringify(serviceActionData)

      if (serviceActionData.serviceActionId) {
        storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
        var serviceActionCoID = serviceActionData.serviceActionId

        // Associate service action with NSE subscription
        const associateResponse = await fetch(apiUrl("associate-service-action-with-contact-and-contract"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            serviceActionId: serviceActionCoID,
            nseContractId: nseContractId,
            contactId: contactId,
            nseSubscriptionId: nseSubId,
          }),
        })

        const associateData = await associateResponse.json()
        // BUGFIX: original had a bare `else` with no preceding `if` — syntax
        // error that prevented the browser from parsing the inline script.
        if (!associateResponse.ok) {
          console.error("❌ Association Error:", associateData)
          throw new Error("Failed to associate service action.")
        }
      } else {
        console.error("❌ Service Action Creation Failed:", serviceActionData)
        throw new Error("Failed to create service action.")
      }
    } catch (error) {
      console.error("❌ Error:", error)
    }

    return true
  }
  async function updateDataConsentAdobeUrlInContracts(value, value1, value2, value3) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateDataConsentAdobeUrlInContracts",[value,value1,value2,value3],["value","value1","value2","value3"]);
    var contractId = storage.rawGet("contractId")
    var DataContentSubType = storage.rawGet("DataContentSubType")
    try {
      const prop = {
        properties: {
          saa_document_sub_type_3: DataContentSubType,
          lmi_saa_doc_file_3: value1,
          saa_doc_file_3_id: value2,
          data_consent_document_status: value3,
        },
      }
      const response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })

      if (response.ok) {
        await createNseServiceForDataConsent(value, value1, value2, value3)
        document.querySelector(".dc-thankyou p a").href = selfServeUrl
        document.querySelector(".dc-thankyou").style.display = "block"
        document.querySelector("#firstStepButton").style.display = "none"
        document.querySelector(".dataConsentAgreement").style.display = "none"
        closeProgressBar()
        setTimeout(() => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
          if (selfServeUrl == null || selfServeUrl === "null") {
            window.location.href = "/"
          } else {
            window.location.href = selfServeUrl
          }
        }, 3000)
      }

      const _result = await response.json()
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  decrypteEmail()
  document.querySelector("#firstStepButton").addEventListener("click", async () => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
    openProgressBar("We are saving your signed document to your account")
    await sendDataConsentAgreementIdToGetStatus()
  })
  /* ------------------------------------------------------------ CO Re-process ----------------------------------------------- */

  /* ------------------------------------------------------------ IL Re-process ----------------------------------------------- */

  document.querySelector("#dis-firstStepButton").addEventListener("click", async () => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
    openProgressBar("We are saving your signed document to your account")
    await sendAgreementIdToGetStatus()
  })
  async function sendAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-reprocessing.ts","sendAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealrecordId")
    var agreementId = storage.rawGet("DisagreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${agreementId}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const res = await response.json()
      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        await uploadDisclosurePDF(res.hubspot.url, res.hubspot.id)
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function createNseServiceForDisclosure(_value, value1, value2) {
__ea_trace("modules/consent/consent-reprocessing.ts","createNseServiceForDisclosure",[_value,value1,value2],["_value","value1","value2"]);
    var _utilityDetails = storage.rawGet("UtilitySessionDetails")
    var _dealId = storage.rawGet("dealrecordId")
    var contactId = storage.rawGet("contactId")
    var nseContractId = storage.rawGet("contractId")
    var ErNumber = storage.rawGet("ErNumber")
    var DisclosureSubType = storage.rawGet("DisclosureSubType")
    var nseSubId = storage.rawGet("subscription_record_id")
    try {
      var serviceActionResponse = await fetch(apiUrl("create-nse-service-action-for-re-process-il"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          saa_document_sub_type_1: DisclosureSubType,
          er_number: ErNumber,
          il_disclosure_signed_file: value1,
          lmi_saa_doc_file_1: value1,
          il_disclosure_signed_file_id: value2,
          saa_doc_file_1_id: value2,
        }),
      })
      const serviceActionData = await serviceActionResponse.json()
      _responseFromAPI = JSON.stringify(serviceActionData)

      if (serviceActionData.serviceActionId) {
        storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
        var serviceActionCoID = serviceActionData.serviceActionId

        // Associate service action with NSE subscription
        const associateResponse = await fetch(apiUrl("associate-service-action-with-contact-and-contract"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            serviceActionId: serviceActionCoID,
            nseContractId: nseContractId,
            contactId: contactId,
            nseSubscriptionId: nseSubId,
          }),
        })

        const associateData = await associateResponse.json()

        if (associateData.status !== "success") {
          console.error("❌ Association Error:", associateData)
          throw new Error("Failed to associate service action.")
        }
      } else {
        console.error("❌ Service Action Creation Failed:", serviceActionData)
        throw new Error("Failed to create service action.")
      }
    } catch (error) {
      console.error("❌ Error:", error)
    }

    return true
  }
  async function updateAdobeUrlInContract(value, value1, value2) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateAdobeUrlInContract",[value,value1,value2],["value","value1","value2"]);
    var contractId = storage.rawGet("contractId")
    var DisclosureSubType = storage.rawGet("DisclosureSubType")
    try {
      const prop = {
        properties: {
          il_disclosure_signed_file: value1,
          saa_document_sub_type_1: DisclosureSubType,
          lmi_saa_doc_file_1: value1,
          il_disclosure_signed_file_id: value2,
          saa_doc_file_1_id: value2,
        },
      }
      const response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })

      if (response.ok) {
        await updateAdobeUrl(value, value1, value2)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateAdobeUrl(value, value1, value2) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateAdobeUrl",[value,value1,value2],["value","value1","value2"]);
    var dealId = storage.rawGet("dealrecordId")
    var DisclosureSubType = storage.rawGet("DisclosureSubType")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          il_disclosure_signed_file: value1,
          saa_document_sub_type_1: DisclosureSubType,
          lmi_saa_doc_file_1: value1,
          il_disclosure_signed_file_id: value2,
          saa_doc_file_1_id: value2,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await createNseServiceForDisclosure(value, value1, value2)

        document.querySelector(".dis-thankyou p a").href = selfServeUrl
        document.querySelector(".dis-thankyou").style.display = "block"
        document.querySelector("#dis-firstStepButton").style.display = "none"
        document.querySelector("#signPdf").style.display = "none"
        closeProgressBar()
        setTimeout(() => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
          if (selfServeUrl == null || selfServeUrl === "null") {
            window.location.href = "/"
          } else {
            window.location.href = selfServeUrl
          }
        }, 3000)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function uploadDisclosurePDF(value, value1) {
__ea_trace("modules/consent/consent-reprocessing.ts","uploadDisclosurePDF",[value,value1],["value","value1"]);
    var agreementId = storage.rawGet("DisagreementId")
    var formIddd = storage.rawGet("formId")
    var _catchdata = ""
    try {
      const data = {
        form_id: formIddd,
        form_type: "signed_form",
        doc_signed_form_ext: "pdf",
        agreementId: agreementId,
      }
      const response = await fetch(`https://api.nautilussolar.com/api/sbx/uploadDisclosurePDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      //             catchdata = data;
      if (response.ok) {
        const result = await response.json()
        if (result.url !== undefined && result.url != null) {
          await updateAdobeUrlInContract(result.url, value, value1)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateAgreementId(value, formid, formStatus, _val1) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateAgreementId",[value,formid,formStatus,_val1],["value","formid","formStatus","_val1"]);
    var contractId = storage.rawGet("contractId")
    try {
      var prop = {
        properties: {
          adobe_agreement_id: value,
          il_formid: formid,
          il_formstatus: formStatus,
        },
      }
      const _response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function getAgreementUrl(adobe_agreement_id) {
__ea_trace("modules/consent/consent-reprocessing.ts","getAgreementUrl",[adobe_agreement_id],["adobe_agreement_id"]);
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const result = await response.json()
      if (result.data.code === "AGREEMENT_NOT_SIGNABLE") {
        await sendAgreementIdToGetStatus()
        alert("Disclosure Agreement already signed")
        document.querySelector(".dis-thankyou p a").href = selfServeUrl
        document.querySelector(".dis-thankyou").style.display = "block"
        document.querySelector("#dis-firstStepButton").style.display = "none"
        document.querySelector("#signPdf").style.display = "none"
        closeProgressBar()
        setTimeout(() => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
          if (selfServeUrl == null || selfServeUrl === "null") {
            window.location.href = "/"
          } else {
            window.location.href = selfServeUrl
          }
        }, 3000)
      } else {
        var esignUrl = result.data.signingUrlSetInfos[0].signingUrls[0].esignUrl
        var agreementId = result.agreementId
        storage.rawSet("DisagreementId", agreementId)
        document.querySelector("#signPdf").src = esignUrl
        document.querySelector("#signPdf").style.display = "block"
        document.querySelector("#dis-firstStepButton").style.display = "block"
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function sendBase64Toserverless(formid, formStatus, val1) {
__ea_trace("modules/consent/consent-reprocessing.ts","sendBase64Toserverless",[formid,formStatus,val1],["formid","formStatus","val1"]);
    var formPdfff = storage.rawGet("formPdf")
    var _formIddd = storage.rawGet("formId")
    var fullName = storage.rawGet("LoggedName")
    var dealId = storage.rawGet("dealrecordId")
    var projectName = `${fullName} ${dealId}`
    var userEmail = storage.rawGet("customerEmail")
    var _catchdata = ""
    try {
      const data = {
        base64File: formPdfff,
        pdfName: projectName,
        email: userEmail,
        templateId: "CBJCHBCAABAAl7NlJN0upbWzS6u94ijsSZF1k_MXsCht",
      }
      const response = await fetch(apiUrl("ConvertBaseToBuffer"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      if (response.ok) {
        const result = await response.json()
        var esignUrl = result.data.signingUrlSetInfos[0].signingUrls[0].esignUrl
        var agreementId = result.agreementId
        storage.rawSet("DisagreementId", agreementId)
        await updateAgreementId(agreementId, formid, formStatus, val1)
        document.querySelector("#signPdf").src = esignUrl
        document.querySelector("#signPdf").style.display = "block"
        document.querySelector("#dis-firstStepButton").style.display = "block"
        closeProgressBar()
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  async function updateFormId(value, formStatus, espfy, ebcfy, ebcfyv2, tsfy, res) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateFormId",[value,formStatus,espfy,ebcfy,ebcfyv2,tsfy,res],["value","formStatus","espfy","ebcfy","ebcfyv2","tsfy","res"]);
    var dealId = storage.rawGet("dealrecordId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          il_formid: value,
          total_saving_first_year: tsfy,
          il_formstatus: formStatus,
          estimated_subscription_payment_first_year: espfy,
          estimated_bill_credits_first_year: ebcfy,
          estimated_bill_credits_first_year_v2: ebcfyv2,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await sendBase64Toserverless(value, formStatus, res)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateElectricityDataInContracts(_value, _value1, _value2, _value3) {
__ea_trace("modules/consent/consent-reprocessing.ts","updateElectricityDataInContracts",[_value,_value1,_value2,_value3],["_value","_value1","_value2","_value3"]);
    var contractId = storage.rawGet("contractId")
    var _utilityDetails = storage.rawGet("UtilitySessionDetails")
    try {
      const prop = {
        properties: {
          usage_period_from: storage.rawGet("usage_period_from"),
          usage_period_to: storage.rawGet("usage_period_to"),
          usage_period_days: storage.rawGet("usage_period_days"),
          electricity_consumption_wh: storage.rawGet("electricity_consumption_Wh"),
          electricity_consumption_davg_wh: storage.rawGet("electricity_consumption_davg_Wh"),
          electricity_consumption_watts: storage.rawGet("electricity_consumption_Watts"),
          electricity_consumption_kwh: storage.rawGet("electricity_consumption_kWh"),
          electricity_consumption_davg_kwh: storage.rawGet("electricity_consumption_davg_kWh"),
          electricity_consumption_kwatts: storage.rawGet("electricity_consumption_kWatts"),
          utility_rate: storage.rawGet("UtilityRate"),
          payment_amount_per_kwh: storage.rawGet("payment_amount_per_kwh"),
          sub_sizing_factor: storage.rawGet("SubSizingFactor"),
          subscription_size_kwac: storage.rawGet("subscription_size_kWAC"),
          gross_electricity_production: storage.rawGet("gross_electricity_production"),
        },
      }
      const _response = await fetch(apiUrl("update-data-in-contracts"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contractId: contractId,
          properties: prop.properties,
        }),
      })
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function _getBillsandConsumptionData() {
__ea_trace("modules/consent/consent-reprocessing.ts","_getBillsandConsumptionData",[],[]);
    var _contactId = storage.rawGet("contactId")
    var deallId = storage.rawGet("dealrecordId")
    var customerId = storage.rawGet("bayousId")
    var FarmCity = storage.rawGet("FarmCity")
    var accountNumber = storage.rawGet("uan1Value")
    var meterId = storage.rawGet("meterId")
    var meterAddAtt = storage.rawGet("additionalAttribute")
    var meterAddAttVal = storage.rawGet("uan2Value")
    var _catchdata = ""
    try {
      var data
      if (utilityId === "AMCIPS-SF") {
        data = {
          customer_id: customerId,
          account_number: accountNumber,
        }
      } else {
        data = {
          customer_id: customerId,
          account_number: accountNumber,
          meter_id: meterId,
          meter_additional_attribute: meterAddAtt,
          meter_additional_attribute_value: meterAddAttVal,
        }
      }
      const response = await fetch("https://api.nautilussolar.com/api/getConsumption", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      var _consumRes = JSON.stringify(dataa)

      if (response.ok) {
        var usage_period_from = dataa.data.usage_period_from
        var usage_period_to = dataa.data.usage_period_to
        var usage_period_days = dataa.data.usage_period_days
        var electricity_consumption_Wh = dataa.data.electricity_consumption_Wh
        var electricity_consumption_davg_Wh = dataa.data.electricity_consumption_davg_Wh
        var electricity_consumption_Watts = dataa.data.electricity_consumption_Watts
        var electricity_consumption_kWh = dataa.data.electricity_consumption_kWh
        var electricity_consumption_davg_kWh = dataa.data.electricity_consumption_davg_kWh
        var electricity_consumption_kWatts = dataa.data.electricity_consumption_kWatts
        var utilityRate = storage.rawGet("UtilityRate")
        var subSizingFactor = storage.rawGet("SubSizingFactor")
        var standardRate = storage.rawGet("standardRate")
        var _lmiNseRate = storage.rawGet("lmiNseRate")
        var acSystemSize = storage.rawGet("acSystemSize")
        var acKwh = storage.rawGet("acKwh")
        var subscription_size_kWAC =
          (((electricity_consumption_kWh / usage_period_days) * 365 * subSizingFactor) / acKwh) * acSystemSize
        var gross_electricity_production = (electricity_consumption_kWh / usage_period_days) * 365 * subSizingFactor
        var estimatedAnnualEleCost = gross_electricity_production * utilityRate
        var payment_amount_per_kwh = utilityRate * standardRate

        storage.rawSet("usage_period_from", usage_period_from)
        storage.rawSet("usage_period_to", usage_period_to)
        storage.rawSet("usage_period_days", usage_period_days)
        storage.rawSet("electricity_consumption_Wh", electricity_consumption_Wh)
        storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_Wh)
        storage.rawSet("electricity_consumption_Watts", electricity_consumption_Watts)
        storage.rawSet("electricity_consumption_kWh", electricity_consumption_kWh)
        storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kWh)
        storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kWatts)
        storage.rawSet("subscription_size_kWAC", subscription_size_kWAC)
        storage.rawSet("gross_electricity_production", gross_electricity_production)
        storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
        storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)

        var fileurl0 = "",
          fileurl1 = "",
          fileurl2 = "",
          fileurl3 = "",
          fileurl4 = "",
          fileurl5 = "",
          fileurl6 = "",
          fileurl7 = "",
          fileurl8 = "",
          fileurl9 = "",
          fileurl10 = "",
          fileurl11 = ""
        var fileid0 = "",
          fileid1 = "",
          fileid2 = "",
          fileid3 = "",
          fileid4 = "",
          fileid5 = "",
          fileid6 = "",
          fileid7 = "",
          fileid8 = "",
          fileid9 = "",
          fileid10 = "",
          fileid11 = ""
        for (var i = 0; i < dataa.data.bills.length; i++) {
          if (i === 0) {
            fileurl0 = dataa.data.bills[i].hubspot.url
            fileid0 = dataa.data.bills[i].hubspot.id
          }
          if (i === 1) {
            fileurl1 = dataa.data.bills[i].hubspot.url
            fileid1 = dataa.data.bills[i].hubspot.id
          }
          if (i === 2) {
            fileurl2 = dataa.data.bills[i].hubspot.url
            fileid2 = dataa.data.bills[i].hubspot.id
          }
          if (i === 3) {
            fileurl3 = dataa.data.bills[i].hubspot.url
            fileid3 = dataa.data.bills[i].hubspot.id
          }
          if (i === 4) {
            fileurl4 = dataa.data.bills[i].hubspot.url
            fileid4 = dataa.data.bills[i].hubspot.id
          }
          if (i === 5) {
            fileurl5 = dataa.data.bills[i].hubspot.url
            fileid5 = dataa.data.bills[i].hubspot.id
          }
          if (i === 6) {
            fileurl6 = dataa.data.bills[i].hubspot.url
            fileid6 = dataa.data.bills[i].hubspot.id
          }
          if (i === 7) {
            fileurl7 = dataa.data.bills[i].hubspot.url
            fileid7 = dataa.data.bills[i].hubspot.id
          }
          if (i === 8) {
            fileurl8 = dataa.data.bills[i].hubspot.url
            fileid8 = dataa.data.bills[i].hubspot.id
          }
          if (i === 9) {
            fileurl9 = dataa.data.bills[i].hubspot.url
            fileid9 = dataa.data.bills[i].hubspot.id
          }
          if (i === 10) {
            fileurl10 = dataa.data.bills[i].hubspot.url
            fileid10 = dataa.data.bills[i].hubspot.id
          }
          if (i === 11) {
            fileurl11 = dataa.data.bills[i].hubspot.url
            fileid11 = dataa.data.bills[i].hubspot.id
          }
          if (i === 0) {
          }
        }
      } else {
        setTimeout(async () => {
__ea_trace("modules/consent/consent-reprocessing.ts","(anon)",[],[]);
          openProgressBar("We are securing your data.")
          await _getBillsandConsumptionData()
        }, 10000)
        return
      }
      try {
        const prop = {
          properties: {
            deal_id: deallId,
            utility_bill_file_1_url: fileurl0,
            utility_bill_file_2_url: fileurl1,
            utility_bill_file_3_url: fileurl2,
            utility_bill_file_4_url: fileurl3,
            utility_bill_file_5_url: fileurl4,
            utility_bill_file_6_url: fileurl5,
            utility_bill_file_7_url: fileurl6,
            utility_bill_file_8_url: fileurl7,
            utility_bill_file_9_url: fileurl8,
            utility_bill_file_10_: fileurl9,
            utility_bill_file_11_: fileurl10,
            utility_bill_file_12_: fileurl11,
            utility_bill_file_1_id: fileid0,
            utility_bill_file_2_id: fileid1,
            utility_bill_file_3_id: fileid2,
            utility_bill_file_4_id: fileid3,
            utility_bill_file_5_id: fileid4,
            utility_bill_file_6_id: fileid5,
            utility_bill_file_7_id: fileid6,
            utility_bill_file_8_id: fileid7,
            utility_bill_file_9_id: fileid8,
            utility_bill_file_10_id: fileid9,
            utility_bill_file_11_id: fileid10,
            utility_bill_file_12_id: fileid11,
            name_1: "Credit Card Fee",
            amount_1: "2.90%",
            form_type: "csf_form",
            spanish_pdf: "No",
            invoice_type: "Electronic",
            payment_frequency: "Monthly, within 60 days after energization",
            subscription_type: "Price per kWh produced by subscription",
            when_applicable_1: "Applicable for Credit Card Payments",
            provider_email: "customercare@nautilussolar.com",
            provider_phone_number: "8669694129",
            provider_website: "www.nautilussolar.com",
            provider_address_dba_name: "Nautilus Community Solar, LLC",
            il_provider_company_name: "Nautilus US Power Holdco, LLC",
            minimum_level_guarantee: "no",
            termination_circ:
              "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
            require_ares: "No",
            terms_years: "20",
            il_payment_method: "ACH",
            initial_amount: "0",
            vendor_id: "2177",
            nearest_inhabited_area: FarmCity,
          },
        }
        const resp = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(prop),
        })
        _catchdata = prop
        if (resp.ok) {
          await updateElectricityDataInContracts()
          await sendDatatoCreateDisclouser()
        }

        const res = await resp.json()
        _responseFromAPI = JSON.stringify(res)
      } catch (error) {
        console.error("Error:", error)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  function generateUniqueNumber() {
__ea_trace("modules/consent/consent-reprocessing.ts","generateUniqueNumber",[],[]);
    const timestamp = Date.now() // milliseconds since Jan 1, 1970
    const random = Math.floor(Math.random() * 100000) // random 5-digit number
    return Number(`${timestamp}${random}`)
  }

  // Example usage
  async function sendDatatoCreateDisclouser() {
__ea_trace("modules/consent/consent-reprocessing.ts","sendDatatoCreateDisclouser",[],[]);
    var fullName = storage.rawGet("LoggedName")
    var _dealId = storage.rawGet("dealrecordId")
    var contractId = storage.rawGet("contractId")
    var projectName = `${fullName} ${contractId} ${generateUniqueNumber()}`
    var UtilitySessionDetails = JSON.parse(storage.rawGet("UtilitySessionDetails"))
    var zipCode = storage.rawGet("ZipCode")
    if (zipCode === undefined || zipCode === "undefined" || zipCode == null || zipCode === "null") {
      zipCode = ""
    }
    var _FarmCity = storage.rawGet("FarmCity")
    var City = storage.rawGet("city")
    if (City === undefined || City === "undefined" || City == null || City === "null") {
      City = ""
    }
    var _UanNumber = storage.rawGet("UanNumber")
    var userEmail = storage.rawGet("customerEmail")
    var CellPhone = storage.rawGet("CellPhone")
    var HomePhone = storage.rawGet("HomePhone")
    if (CellPhone == null || CellPhone === "" || CellPhone === undefined) {
      CellPhone = HomePhone
    }
    var combinedNumber = storage.rawGet("utilityAccountNumber")
    var streetaddress = storage.rawGet("street_address")
    var streetaddress2 = storage.rawGet("street_address_2")
    if (combinedNumber === undefined || combinedNumber === "undefined") {
      combinedNumber = ""
    }
    if (
      streetaddress === undefined ||
      streetaddress === "undefined" ||
      streetaddress == null ||
      streetaddress === "null"
    ) {
      streetaddress = ""
    }
    if (
      streetaddress2 === undefined ||
      streetaddress2 === "undefined" ||
      streetaddress2 == null ||
      streetaddress2 === "null"
    ) {
      streetaddress2 = ""
    }
    var gross_electricity_production = storage.rawGet("gross_electricity_production")
    var payment_amount_per_kwh = storage.rawGet("payment_amount_per_kwh")
    var subscription_size_kWAC = storage.rawGet("subscription_size_kWAC")

    try {
      const data = {
        name_1: "Credit Card Fee",
        amount_1: "2.90%",
        form_type: "csf_form",
        vendor_id: 2177,
        Spanish_PDF: "No",
        start_month: "2025-08",
        terms_years: 20,
        invoice_type: "Electronic",
        project_name: projectName, //dynamic
        require_ARES: "no",
        terms_months: 1,
        initial_amount: "0",
        payment_method: "ACH",
        payment_formula: null,
        electric_utility: UtilitySessionDetails["11"], //dynamic (Utility_ID_3 we are getting from Session Config)
        termination_circ:
          "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
        payment_frequency: "Monthly, within 60 days after energization",
        subscription_type: "Price per kWh produced by subscription",
        when_applicable_1: "Applicable for Credit Card Payments",
        initial_supply_rate: null,
        is_autopay_required: "Yes",
        supply_rate_formula: null,
        termination_penalty: "No",
        payment_amount_perkwh: payment_amount_per_kwh,
        annual_escalation_rate: null,
        auto_esign_email_optin: "No",
        nearest_inhabited_area: City,
        provider_address_email: "customercare@nautilussolar.com",
        provider_address_phone: "8669694129",
        subscriber_address_zip: zipCode, //dynamic
        subscription_size_kWAC: subscription_size_kWAC,
        explanatory_information: null,
        minimum_level_guarantee: "no",
        sub_utility_acct_number: combinedNumber, //dynamic (Combined Utility Account Number)
        subscriber_address_city: City, //dynamic
        termination_application: null,
        provider_address_website: "www.nautilussolar.com",
        subscriber_address_email: userEmail, //dynamic
        subscriber_address_phone: CellPhone, //dynamic
        subscriber_address_state: "IL", //dynamic
        provider_address_dba_name: "Nautilus Community Solar, LLC",
        subscriber_address_address1: streetaddress, //dynamic
        subscriber_address_address2: streetaddress2, //dynamic
        gross_electricity_production: gross_electricity_production,
        subscriber_address_attention: fullName, //dynamic
        provider_address_company_name: "Nautilus US Power Holdco, LLC",
        is_payment_through_utility_bill: "No",
        substitute_auto_esign_emailaddr: null,
        Is_cs_provider_required_to_be_utility_agent: "Yes",
        is_advanced_notice_required_for_termination: "No",
      }
      const response = await fetch(`https://api.nautilussolar.com/api/sbx/createDisclosurePDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      const data1 = await response.json()
      var formId = data1.messageDetails.pdfGenerationMessage.data[0].form_id
      var formPdf = data1.messageDetails.pdfGenerationMessage.data[0].form_pdf
      var formStatus = data1.messageDetails.pdfGenerationMessage.data[0].form_status
      var espfy = data1.messageDetails.pdfGenerationMessage.data[0].estimated_subscription_payment_first_year
      var ebcfy = data1.messageDetails.pdfGenerationMessage.data[0].estimated_bill_credits_first_year
      var ebcfyv2 = data1.messageDetails.pdfGenerationMessage.data[0].estimated_bill_credits_first_year_v2
      var tsfy = data1.messageDetails.pdfGenerationMessage.data[0].total_savings_first_year

      document.querySelector("#signPdf").src = `data:application/pdf;base64,${formPdf}`
      storage.rawSet("formId", formId)
      storage.rawSet("formPdf", formPdf)
      await updateFormId(formId, formStatus, espfy, ebcfy, ebcfyv2, tsfy, data1)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }

  /* ------------------------------------------------------------ IL Re-process ----------------------------------------------- */

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")
}
